import React from 'react';
import { fileValidation } from '../../../../util/yupUtils';
import FormSection from '../../../common/hookFormComponents/FormSection';

const fields = [
  {
    fieldType: 'file',
    colSpan: 1,
    name: 'vatChallan',
    type: 'file',
    label: 'VAT Challan (PDF/JPG/JPEG-Max 5mb)',
    isRequired: true,
  },
  {
    fieldType: 'file',
    colSpan: 1,
    name: 'lcCertificate',
    type: 'file',
    label: 'L/C Certificate (PDF/JPG/JPEG-Max 5mb)',
    isRequired: true,
  },
  {
    fieldType: 'file',
    colSpan: 1,
    name: 'purchaseOrder',
    type: 'file',
    label: 'Purchase Order (PDF/JPG/JPEG-Max 5mb)',
    isRequired: true,
  },
  {
    fieldType: 'file',
    colSpan: 1,
    name: 'deliveryChallan',
    type: 'file',
    label: 'Delivery Challan (PDF/JPG/JPEG-Max 5mb)',
    isRequired: true,
  },
  {
    fieldType: 'file',
    colSpan: 1,
    name: 'proformaInvoice',
    type: 'file',
    label: 'Proforma Invoice (PDF/JPG/JPEG-Max 5mb)',
    isRequired: true,
  },
  {
    fieldType: 'file',
    colSpan: 1,
    name: 'commercialInvoice',
    type: 'file',
    label: 'Commercial Invoice (PDF/JPG/JPEG-Max 5mb)',
    isRequired: true,
  },
  {
    fieldType: 'file',
    colSpan: 1,
    name: 'lcBankDocuments',
    type: 'file',
    label: 'L/C Bank Documents (PDF/JPG/JPEG-Max 5mb)',
    isRequired: true,
  },
];

let obj1 = {};
let obj2 = {};

fields.forEach(
  (field, index) =>
    (obj1[field.name] = index === 0 ? fileValidation.required : fileValidation.optional),
);

fields.forEach((field) => (obj2[field.name] = fileValidation.optional));

export const gspAdditionalDocumentValidation = obj1;
export const gspAdditionalDocumentValidationAlt = obj2;

const GspAdditionalDocumentsSection = (props) => {
  return (
    <FormSection
      sectionName="Upload Additional Documents"
      sectionColumn={1}
      formFields={fields}
      {...props}
    />
  );
};

export default GspAdditionalDocumentsSection;
